/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAccountingPeriod = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M7 4V2h2v2h6V2h2v2h5v18H2V4zm0 2H4v14h16V6h-3v2h-2V6H9v2H7zm2 4v8H7v-8zm8 2v6h-2v-6zm-4 2v4h-2v-4z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgAccountingPeriod as AccountingPeriod };
